<template>
  <div class="export-excursion-policy">
    <cs-button
      id="btnExportExcursionPolicy"
      primary
      :disabled="excursionPolicyExportActionEnabled"
      left-icon="mdi-format-indent-increase"
      label="Export Checklists / Policies"
      @click="displayExcursionPolicyExportModalWithPresaveConfirmation"
    />
    <cs-form-dialog
      id="dlg-export-excursion-policy"
      v-model="excursionPolicyExportModalDisplayed"
      body-id="dlg-export-excursion-policy-body"
      :heading="dialogHeading"
      :primary-action="{
        label: 'Export',
        eventName: 'primary-click',
        disabled: disableExportExcursion || policyDownloadActionInProgress,
        loading: policyDownloadActionInProgress
      }"
      :secondary-action1="{
        label: 'Cancel',
        eventName: 'secondary1-click'
      }"
      @primary-click="downloadExcursionPoliciesPdf"
      @secondary1-click="excursionPolicyExportModalDisplayed = false"
    >
      <template #cs-form-dialog-content>
        <v-container>
          <v-row v-if="excursionPolicyViewActionEnabled" no-gutters>
            <v-col cols="12" class="py-2">
              <strong>Excursion Policies</strong>
            </v-col>
            <v-col cols="12">
              <v-row justify="space-between">
                <v-col cols="10" class="py-0">
                  <v-checkbox
                    id="export-excursion-policy--export-excursion-policy"
                    v-model="excursionPolicyExportChecked"
                    label="Export Excursion Policy"
                    class="excursion-policy-item"
                    color="primary"
                    density="compact"
                    @update:model-value="changeMasterExcursionPolicy"
                  />
                </v-col>
                <v-col cols="2" class="py-0">
                  <view-policy
                    :show-view-policy-label="true"
                    :master-policy-exported="false"
                    :excursion-policy-exported="true"
                    class="pa-0 ma-0"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-row justify="space-between">
                <v-col cols="10" class="py-0">
                  <v-checkbox
                    id="export-excursion-policy--export-master-excursion-policy"
                    v-model="masterPolicyExportChecked"
                    label="Export Master Excursion Policy"
                    class="excursion-policy-item"
                    testing-id="masterExcursionPolicy"
                    color="primary"
                    density="compact"
                    @update:model-value="changeExcursionPolicy"
                  />
                </v-col>
                <v-col cols="2" class="py-0">
                  <view-policy
                    :show-view-policy-label="true"
                    :master-policy-exported="true"
                    :excursion-policy-exported="false"
                    class="pa-0 ma-0"
                  />
                </v-col>
              </v-row>
            </v-col>
            <div class="w-100 pb-5">
              <hr />
            </div>
            <v-col v-for="item in items" :key="item.id" cols="12">
              <v-row justify="space-between">
                <v-col cols="10" class="py-0">
                  <v-checkbox
                    :id="getChecklistItemId(item)"
                    v-model="item.ticked"
                    :disabled="!item.isActive"
                    :label="item.name"
                    density="compact"
                    color="primary"
                    class="excursion-policy-item"
                    @update:model-value="checkRiskItem()"
                  />
                </v-col>
                <v-col cols="2" class="py-0">
                  <view-policy
                    :category-name="item.name"
                    :element-disabled="!item.isActive"
                    :show-view-policy-label="true"
                    class="pa-0 ma-0"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12" class="py-2">
              <strong>Excursion Checklists</strong>
            </v-col>
            <v-col cols="12">
              <v-row justify="space-between">
                <v-col cols="9" class="py-0">
                  <v-checkbox
                    id="export-excursion-policy--mandatory-excursion-checklists"
                    v-model="mandatoryExcursionChecklistsExportChecked"
                    class="excursion-policy-item"
                    label="Mandatory Excursion Checklists"
                    color="primary"
                    density="compact"
                  />
                </v-col>
                <v-col cols="3" class="pa-0 d-flex justify-end">
                  <view-all-mandatory-checklist></view-all-mandatory-checklist>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-row justify="space-between">
                <v-col cols="9" class="py-0">
                  <v-checkbox
                    id="export-excursion-policy--risk-category-checklists"
                    v-model="categoryChecklistsExported"
                    :disabled="checklistViewActionEnabled"
                    class="excursion-policy-item"
                    label="Risk Category Checklists"
                    color="primary"
                    density="compact"
                  />
                </v-col>
                <v-col cols="3" class="pa-0 d-flex justify-end">
                  <complete-checklist
                    :checklist-read-only="true"
                    :checklist-view-mode-enabled="true"
                    :checklist-view-action-enabled="checklistViewActionEnabled"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col v-for="item in activityItems" :key="item.name" cols="12">
              <v-row justify="space-between">
                <v-col cols="9" class="py-0">
                  <v-checkbox
                    :id="getChecklistItemId(item)"
                    v-model="item.ticked"
                    :label="item.name"
                    color="primary"
                    density="compact"
                  />
                </v-col>
                <v-col cols="3" class="pa-0 d-flex justify-end">
                  <complete-checklist
                    :category-name="item.activityClassesName"
                    :risk-type-name="item.riskTypeName"
                    :risk-class-name="item.riskClassName"
                    :checklist-view-mode-enabled="true"
                  ></complete-checklist>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </cs-form-dialog>
    <cs-form-dialog
      id="dlg-export-excursion-policy-presave-confirm"
      v-model="presaveConfirmationDialogDisplayed"
      body-id="dlg-export-excursion-policy-presave-confirm-body"
      heading="Export Excursion Policy"
      :primary-action="{
        label: 'Save',
        eventName: 'primary-click',
        disabled: excursionSaveActionInProgress,
        loading: excursionSaveActionInProgress
      }"
      :secondary-action1="{
        label: 'Cancel',
        eventName: 'secondary1-click'
      }"
      @primary-click="saveExcursion"
      @secondary1-click="
        presaveConfirmationDialogDisplayed = false;
        excursionSaveActionInProgress = false;
      "
    >
      <template #cs-form-dialog-content>You need to Save before you can export.</template>
    </cs-form-dialog>
  </div>
</template>

<script>
import CompleteChecklist from './CompleteChecklist';
import ViewAllMandatoryChecklist from './ViewAllMandatoryChecklist';

export default {
  name: 'ExportExcursionPolicy',
  components: {
    CompleteChecklist,
    ViewAllMandatoryChecklist
  },
  props: {
    excursionPolicyExportActionEnabled: {
      type: Boolean,
      required: false,
      default: false
    },
    valuesChanged: Boolean,
    submitExcursion: {
      type: Function,
      default: () => {}
    },
    excursionBuilderViewDisplayed: Boolean
  },
  data() {
    return {
      excursionPolicyExportModalDisplayed: false,
      excursionPolicyExportChecked: false,
      masterPolicyExportChecked: false,
      items: [],
      policyDownloadActionInProgress: false,
      excursionSaveActionInProgress: false,
      excludeRiskCategory: 'Outdoor Education Providers',
      mandatoryExcursionChecklistsExportChecked: false,
      activityItems: [],
      excursionPolicyViewActionEnabled: false,
      presaveConfirmationDialogDisplayed: false,
      categoryChecklistsExported: false
    };
  },
  computed: {
    disableExportExcursion() {
      let disabled = true;
      if (this.masterPolicyExportChecked || this.excursionPolicyExportChecked) {
        disabled = false;
      } else {
        this.items.forEach((item) => {
          if (item.ticked) {
            disabled = false;
          }
        });

        if (this.mandatoryExcursionChecklistsExportChecked) {
          disabled = false;
        }

        if (this.categoryChecklistsExported) {
          disabled = false;
        }

        this.activityItems.forEach((item) => {
          if (item.ticked) {
            disabled = false;
          }
        });
      }
      return disabled;
    },
    checklistViewActionEnabled() {
      let disabled = true;
      const selectedExcursion = this.$store.state.common.excursionDc;

      const { categories } = selectedExcursion;
      if (categories && categories.length > 0) {
        const categoryComplete = selectedExcursion.categories.filter(
          (c) =>
            c.name.toLowerCase() !== 'activities' &&
            c.CompleteChecklist &&
            c.CompleteChecklist.length > 0
        );

        disabled = !(categoryComplete && categoryComplete.length > 0);
      }

      return disabled;
    },
    dialogHeading() {
      if (this.excursionPolicyViewActionEnabled) {
        return 'Excursion Policies and Checklists';
      }
      return 'Export Excursion Policy';
    }
  },
  created() {
    this.generateRiskData();
  },
  methods: {
    getPolicyRiskCategoryChecklistItemId(item) {
      return `export-excursion-policy--risk-category-checklist-item-checkbox--label--${item.name.replace(
        /\s*/g,
        ''
      )}`;
    },
    getCheckRiskItemCheckboxLabel(item) {
      return `export-excursion-policy--risk-item-checkbox--label--${item.name.replace(/\s*/g, '')}`;
    },
    getChecklistItemId(item) {
      return `export-excursion-policy--${item.name.replace(/\s*/g, '')}`;
    },
    generateRiskData() {
      this.items = [];
      this.excursionPolicyViewActionEnabled =
        this.$store.state.common.excursionPolicyViewActionEnabled;
      this.categoryChecklistsExported = false;
      this.mandatoryExcursionChecklistsExportChecked = false;
      this.masterPolicyExportChecked = false;
      this.excursionPolicyExportChecked = false;
      const allRisk = this.$store.state.common.allRisks;
      const selectedRisk = this.$store.state.common.excursionDc.categories;
      this.activityItems = [];

      if (allRisk && allRisk.length > 0) {
        allRisk.forEach((item) => {
          const riskTreeItem = {
            id: item.id,
            name: item.name,
            ticked: false,
            isActive: false
          };

          if (selectedRisk && selectedRisk.length > 0) {
            const existRisk = selectedRisk.find((sk) => {
              return `${sk.name}` === `${item.name}`;
            });

            if (
              existRisk &&
              existRisk.name !== this.excludeRiskCategory &&
              existRisk.types &&
              existRisk.types.length > 0
            ) {
              existRisk.types.forEach((type) => {
                if (type && type.classes && type.classes.length > 0) {
                  riskTreeItem.isActive = true;

                  if (item.name === 'Activities') {
                    this.generateActivityData(type.classes, type.name, item.name);
                  }
                }
              });
            } else if (existRisk && existRisk.name === this.excludeRiskCategory) {
              riskTreeItem.isActive = true;
            }
          }

          this.items.push(riskTreeItem);
        });
      }
    },
    generateActivityData(classes, riskTypeName, activityClassesName) {
      classes.forEach((item) => {
        this.activityItems.push({
          name: item.name,
          riskTypeName,
          riskClassName: item.name,
          activityClassesName,
          ticked: false,
          checklist: item.CompleteChecklist
        });
      });
    },
    async downloadExcursionPoliciesPdf() {
      this.policyDownloadActionInProgress = true;

      const exportedCategoryChecklists = [];
      if (this.activityItems && this.activityItems.length > 0) {
        this.activityItems.forEach((item) => {
          if (item.ticked) {
            exportedCategoryChecklists.push(item.name);
          }
        });
      }

      const { query } = this.$route;
      const clientLogoEnabled = !(query && query.referrer && query.referrer === 'pcg');

      const params = {
        masterPolicyExported: this.masterPolicyExportChecked,
        excursionPolicyExported: this.excursionPolicyExportChecked,
        exportedItems: this.items,
        clientLogoEnabled,
        mandatoryChecklistsExported: this.mandatoryExcursionChecklistsExportChecked,
        exportedCategoryChecklists,
        categoryChecklistsExported: this.categoryChecklistsExported
      };

      const excursionCommonAdapter = new this.$app.excursionCommon.Adapter({
        store: this.$store,
        app: this.$app
      });

      await excursionCommonAdapter.downloadExcursionRiskContentsPdf(
        this.$route.query,
        params,
        this.$app.deviceDetector
      );

      this.policyDownloadActionInProgress = false;
      this.excursionPolicyExportModalDisplayed = false;
      this.categoryChecklistsExported = false;
    },
    checkRiskItem() {
      this.masterPolicyExportChecked = false;
      this.excursionPolicyExportChecked = false;
    },
    checkRiskItemByTitle(item) {
      if (!item.isActive) {
        return;
      }
      this.masterPolicyExportChecked = false;
      this.excursionPolicyExportChecked = false;
      // eslint-disable-next-line no-param-reassign
      item.ticked = !item.ticked;
    },
    changeExcursionPolicy() {
      if (this.masterPolicyExportChecked && this.items && this.items.length) {
        this.excursionPolicyExportChecked = false;
      }
      this.clearLinesChecking();
    },
    changeMasterExcursionPolicy() {
      if (this.excursionPolicyExportChecked && this.items && this.items.length) {
        this.masterPolicyExportChecked = false;
      }
      this.clearLinesChecking();
    },
    clearLinesChecking() {
      if (this.items && this.items.length > 0) {
        this.items.forEach((item) => {
          // eslint-disable-next-line no-param-reassign
          item.ticked = false;
        });
      }
    },
    saveExcursion() {
      this.excursionSaveActionInProgress = true;
      if (this.excursionBuilderViewDisplayed) {
        this.submitExcursion(null, false, () => {
          this.excursionSaveActionInProgress = false;
          this.presaveConfirmationDialogDisplayed = false;
          this.excursionPolicyExportModalDisplayed = true;
          this.generateRiskData();
        });
      } else {
        this.submitExcursion(
          null,
          false,
          () => {
            this.excursionSaveActionInProgress = false;
            this.presaveConfirmationDialogDisplayed = false;
            this.excursionPolicyExportModalDisplayed = true;
            this.generateRiskData();
          },
          'downloadExcursionPolicy'
        );
      }
    },
    displayExcursionPolicyExportModalWithPresaveConfirmation() {
      if (
        this.submitExcursion &&
        typeof this.submitExcursion === 'function' &&
        this.valuesChanged
      ) {
        this.presaveConfirmationDialogDisplayed = true;
      } else {
        this.excursionPolicyExportModalDisplayed = true;
        this.generateRiskData();
      }
    }
  }
};
</script>
<style scoped>
.export-excursion-policy .v-btn {
  margin-left: 0px;
}

.excursion-policy-item {
  cursor: pointer;
}

.container.grid-list-md .layout .flex {
  padding: 0px;
}

.excursion-policy-row-title {
  line-height: 60px;
  cursor: pointer;
  margin-left: 10px;
}

.excursion-policy-row-title:hover {
  cursor: pointer;
}

.v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
  margin-bottom: unset;
}

.v-input--selection-controls {
  margin-top: 12px;
}

.container {
  padding: 0px 24px;
}

.export-excursion-policy .v-btn {
  padding: 0px;
}
</style>
